import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Typography,
} from '@mui/material';
import { PurpleArrowLeft } from 'Images';
import React, { useContext, useEffect, useState } from 'react';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { DocumentDetail } from './DocumentDetail';
import { DocumentsContext, IExtendedDocument } from 'Context/DocumentsContext';

interface IAccordionDocument {
  documents: IExtendedDocument[];
  time: string;
  openOnRender?: boolean;
}
export const AccordionDocument = ({
  documents,
  time,
  openOnRender,
}: IAccordionDocument) => {
  const { filter } = useContext(DocumentsContext);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (openOnRender) setIsOpen(openOnRender);
  }, [openOnRender]);

  if (
    filter.isDocumentSentByUser !== null &&
    documents.every((doc) => doc.isSentToUser !== filter.isDocumentSentByUser)
  )
    return null;

  return (
    <Accordion
      expanded={isOpen}
      onClick={() => setIsOpen(!isOpen)}
      onKeyDown={onEnterOrEscapeKeyDown}
      sx={{
        boxShadow: 'none',
        borderRadius: '0 16px 16px 0',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={
          <Avatar
            alt=''
            src={PurpleArrowLeft}
            sx={{
              width: '20px',
              height: '20px',
              transform: 'rotate(-90deg)',
            }}
          />
        }
        sx={{
          p: '0 24px',
          height: '79px',
          bgcolor: '#F4E4FF',
          borderRadius: '0 16px 16px 0',
          borderLeft: isOpen ? '3px solid #D59DFF' : undefined,
        }}
      >
        <Typography variant='h6'>{time}</Typography>
      </AccordionSummary>
      <AccordionDetails
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
        }}
        sx={{
          p: '0 24px',
          borderLeft: '3px solid #D59DFF',
        }}
      >
        {documents.map((documentItem: IExtendedDocument, index: number) => {
          if (
            filter.isDocumentSentByUser === null ||
            (filter.isDocumentSentByUser !== null &&
              filter.isDocumentSentByUser === documentItem.isSentToUser)
          )
            return <DocumentDetail key={index} data={documentItem} />;
          return null;
        })}
      </AccordionDetails>
    </Accordion>
  );
};
